<script setup>
import { getSimilarityScore } from "./coursesTableUtils";

const props = defineProps({
  similarity: {
    type: Number,
    required: true,
    default: 0, // Defaulting to 0 will hide the similarity match pill.
  },
});

const similarityScore = getSimilarityScore(props.similarity);
</script>


<template>
  <div
    v-if="similarityScore.score"
    :class="similarityScore.color"
    class="inline-block px-3 py-1 rounded-full text-sm font-normal text-white"
  >
    {{ similarityScore.score }}
  </div>
</template>
